<script>
import {authComputed, productMethods} from '@state/helpers'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      avatars: {
        amd: 'amd.png',
        evga: 'evga.jpg',
        target: 'target.png',
        'target online': 'target.png',
        amazon: 'amazon.png',
        antonline: 'antonline.jpg',
        'best buy': 'best buy.png',
        psdirect: 'psdirect.png',
        adorama: 'adorama.png',
        'amazon canada': 'amazon.ca.png',
        'amazon de': 'amazon.de.jpg',
        'amazon france': 'amazon.fr.jpg',
        'amazon uk': 'amazon.uk.jpg',
        gamestop: 'gamestop.png',
        mynavyexchange: 'nex.jpeg',
        microsoft: 'xbox.png',
        shopmyexchange: 'aafes.jpeg',
        walmart: 'walmart.png',
        'b&h photo': 'bhphoto.png',
        bjs: 'bjs.png',
        costco: 'costco.png',
        kohls: 'kohls.png',
        newegg: 'newegg.jpg',
        "sam's club": 'samsclub.jpg',
        'zotac store': 'zotac.jpeg'
      },
      isWorking: false,
      error: null,
      displayItem: this.item,
      zipCode: null,
      placeholders: {
        zipCode: 'Zip Code (optional)'
      }
    }
  },
  computed: {
    ...authComputed,
    avatarPath() {
      const retailer = this.displayItem.retailer.toLowerCase()
      if (this.avatars[retailer]) {
        return require('../assets/images/retailers/' + this.avatars[retailer])
      }

      return null
    },
    availabilityIcon() {
      return this.displayItem.available
        ? 'mdi-check-circle-outline'
        : 'mdi-alpha-x-circle-outline'
    },
    availabilityClass() {
      return this.displayItem.available
        ? this.$style.available
        : this.$style.unavailable
    },
    lastCheckedString() {
      if (!this.displayItem.lastChecked) {
        return ''
      }
      return `${new Date(
        parseInt(this.displayItem.lastChecked)
      ).toLocaleString()}`
    },
  },
  methods: {
    ...productMethods,
    subscribeUnsubscribe(zipCode) {
      const link = this.displayItem
      this.isWorking = true
      const shouldUnsubscribe = (!zipCode && this.displayItem.isSubscribed) || (zipCode && this.displayItem.localEntries && this.displayItem.localEntries.indexOf(zipCode) !== -1)
      if (shouldUnsubscribe) {
        this.unsubscribeToProductSource({ uniqueId: link.uniqueId, zipCode: zipCode })
          .then(() => {
            if (zipCode) {
              this.displayItem.localEntries.splice(this.displayItem.localEntries.indexOf(zipCode), 1)
              this.zipCode = null
            } else {
              this.displayItem.isSubscribed = false
            }
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              this.error = err.response.data.message
            }
          })
          .finally(() => {
            this.isWorking = false
          })
      } else {
        this.subscribeToProductSource({ uniqueId: link.uniqueId, zipCode: zipCode })
          .then(() => {
            if (zipCode) {
              this.displayItem.localEntries.push(zipCode)
              this.zipCode = null
            } else {
              this.displayItem.isSubscribed = true
            }
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              if (
                err.response.data.message &&
                err.response.data.message.toLowerCase().indexOf('drops') !== -1
              ) {
                this.dialog = true
                return
              }

              if (err.response.data.message) {
                if (err.response.data.message.indexOf('active subscription') !== -1 && this.isAppLogin) {
                  window.location.href = 'https://app.inventorybot.io/app/appRoutes/needSubscription';
                } else {
                  this.$swal
                      .fire({
                        title: 'Error!',
                        text: err.response.data.message,
                        icon: 'error',
                        confirmButtonText: 'Go to Settings',
                      })
                      .then((result) => {
                        if (result.isConfirmed) {
                          this.$router.push({name: 'profile'})
                        }
                      })
                }

                return
              } else if (err.response.data.error) {
                this.$swal
                    .fire({
                      title: 'Error!',
                      text: err.response.data.error,
                      icon: 'error',
                    })
                return
              } else {
                this.$swal.fire({
                  title: 'Error!',
                  text: "Something went wrong, It's not your fault",
                  icon: 'error',
                })
              }

              this.error = err.response.data.message
            }
          })
          .finally(() => {
            this.isWorking = false
          })
      }
    },
  },
}
</script>

<template>
  <v-hover v-slot="{ hover }" :class="`${$style.offerContainer} mt-4`">
    <v-card :elevation="hover ? 12 : 2" shaped :class="{ 'on-hover': hover }">
      <a :href="displayItem.url" target="_blank">
        <v-row align="center">
          <v-col v-if="!displayItem.image" cols="2">
            <img
              v-if="avatarPath"
              :class="$style.retailerImage"
              :src="avatarPath"
              :title="displayItem.retailer"
            />
            <span v-else>{{ displayItem.retailer }}</span>
          </v-col>
          <v-col v-else cols="2">
            <img
                v-if="avatarPath"
                :class="$style.retailerImageSmall"
                :src="avatarPath"
                :title="displayItem.retailer"
            />
            <span v-else :class="$style.retailerImageSmall">{{ displayItem.retailer }}</span>
            <img
                :class="$style.productImage"
                :src="displayItem.image"
                :title="displayItem.name"
            />
          </v-col>
          <v-col cols="8">
            <v-card-title
              :class="$style.cardTitle"
              >{{ displayItem.name }}</v-card-title
            >
          </v-col>
          <v-col cols="2">
            <v-icon
              :class="availabilityClass"
              size="40px"
              :title="displayItem.available ? 'Available' : 'Not Available'"
            >
              {{ availabilityIcon }}
            </v-icon>
          </v-col>
        </v-row>
        <v-row>
          <v-col> </v-col>
        </v-row>
      </a>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <BaseButton
                  v-if="!displayItem.isSubscribed"
                  :disabled="isWorking"
                  @click.stop="subscribeUnsubscribe(null)"
              >
                <BaseIcon v-if="isWorking" name="sync" spin />
                <span v-else>
              Subscribe to Listing <span v-if="item.enableZip">for shipping</span>
            </span>
              </BaseButton>

              <BaseButton
                  v-if="displayItem.isSubscribed"
                  :disabled="isWorking"
                  @click.stop="subscribeUnsubscribe(null)"
              >
                <BaseIcon v-if="isWorking" name="sync" spin />
                <span v-else>
              Unsubscribe from Listing <span v-if="item.enableZip">for shipping</span>
            </span>
              </BaseButton>
            </v-col>
          </v-row>

          <v-row v-for="local in displayItem.localEntries" :key="local">
            <v-col>
              <BaseButton
                  :disabled="isWorking"
                  @click.stop="subscribeUnsubscribe(local)"
              >
                <BaseIcon v-if="isWorking" name="sync" spin />
                <span v-else>
                  Unsubscribe from {{local}}
                </span>
              </BaseButton>
            </v-col>
          </v-row>
          <v-row v-if="item.enableZip">
            <v-col><BaseInputText
                v-if="displayItem.enableZip"
                v-model="zipCode"
                name="zipCode"
                type="text"
                :placeholder="placeholders.zipCode"
            />
              <span v-if="displayItem.retailer === 'Target'" :class="$style.zipCodeSubtext">(50 mile radius)</span>
              <span v-if="displayItem.retailer === 'Best Buy'" :class="$style.zipCodeSubtext">(150 mile radius)</span>
            </v-col>
            <v-col>
              <BaseButton
                  v-if="displayItem.enableZip"
                  :disabled="isWorking || !zipCode"
                  @click.stop="subscribeUnsubscribe(zipCode)"
              >
                <BaseIcon v-if="isWorking" name="sync" spin />
                <span v-else>
                Subscribe to zip code
              </span>
              </BaseButton>
            </v-col>
          </v-row>

          <v-row v-if="error">
            <v-col>
              <p>
                {{ error }}
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<style lang="scss" module>
@import '@design';

.offerContainer {
  max-width: 600px;
  gap: 8px;

  a {
    color: black;
    text-decoration: none;
  }
}

.cardTitle {
  display: block;
  width: 100%;
  max-height: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: normal;
}

.zipCodeSubtext {
  font-size: 12px;
  position: relative;
  top: -20px;
}

.available {
  color: green !important;
}

.unavailable {
  color: red !important;
}

.retailerImage {
  width: 60px;
  margin-left: 10px;
}

.retailerImageSmall {
  position: absolute;
  left: 5px;
  top: 15px;
  width: 30px;
}

.productImage {
  width: 60px;
  margin-left: 10px;
}
</style>
